import React from 'react';

import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import GenericRepaymentsCalculator from '@lendi-jam/repayments-calculator';
import parse from 'html-react-parser';

import { GenericRepaymentsCalculatorContent } from '#contentTypes/GenericRepaymentsCalculator';

interface PrismicGenericRepaymentsCalculatorProps {
  component: GenericRepaymentsCalculatorContent;
}

const PrismicGenericRepaymentsCalculator: React.FC<PrismicGenericRepaymentsCalculatorProps> = ({
  component: { primary },
}) => (
  <GenericRepaymentsCalculator
    disclaimer={primary.disclaimer?.text}
    graphHeading={primary.graph_heading?.text}
    showGraph={primary.show_graph}
    resultHeading={primary.result_heading?.text}
    resultBody={primary.result_body?.text}
    calculatorHeading={primary.calculator_heading?.text}
    radioTooltipContent={primary.radio_tooltip_content?.html ? parse(primary.radio_tooltip_content?.html) : undefined}
    buttonLink={embedMarketingTrackingIntoURL(primary.button_link?.url)}
    buttonText={primary.button_text?.text}
  />
);

export default PrismicGenericRepaymentsCalculator;
